import type { GuidedDoctorConsultsState } from './types';

export const DEFAULT_STATE: GuidedDoctorConsultsState = {
  guidedDoctorConsult: {
    fields: {
      notes: '',
      followUpWeekPeriod: null,
    },
    isDirty: false,
    openSections: [],
    accordionInteractionAnimation: true,
  },
};
